
import pay from "./pay";
import buyClass from "./buyClass";
import buyClassAI from "./buyClassAI";
export default [
  ...pay,
  ...buyClass,
  ...buyClassAI
]